import React from 'react';
import PoolsSections from '../../components/UFO/pools/index';  // ✅ Fix import

const PoolsPage = () => {
  return (
    <>
      <PoolsSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default PoolsPage;